import React from 'react';
import { useSelector } from 'react-redux';
import { Header, Image } from 'semantic-ui-react';
import ItemsList from './ItemsList';
import { getMenu } from '../../../selectors';

import './MenuItemsGroup.scss';

const MenuItemsGroup = ({ categoryId, ...props }) => {
    const menu = useSelector(getMenu);
    const category = menu.catalog.categories[categoryId] || {};

    return (
        <div className="pi-menu-items-group">
            <Header as='h2' className="pi-menu-items-group-header">
                {category.imageUrl && <Image src={category.imageUrl} />}
                <Header.Content>
                    {category.name}
                    <Header.Subheader>{category.description}</Header.Subheader>
                </Header.Content>
            </Header>
            <ItemsList items={category.items} />
        </div>
    );
};

export default MenuItemsGroup;
